module.exports = __webpack_public_path__ + "static/media/packageVolume1.a566065b.jpg";